















































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'VenueSpaceBindSelector'

  resources:
    venue_resource:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/venues/:venue.id/edit'
      fetch: false

    spaces:
      resourceName: 'space'
      slug: 'suppliers/:supplierId/spaces'
      params:
        quick_list: true

  vue:
    props: ['venue']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
    }

    data: ->
      selectedVenueSpaces: []
      selectedSpaces: []

    computed:
      supplierId: -> @venue?.top_org_id || @$store.member.supplier.id
      venueSpaceIds: -> @venue.space_ids || []
      venueSpaces: ->
        items = []
        for space in (@spaces || [])
          items.push space if space.id in @venueSpaceIds
        items
      venueSpacesTableData: ->
        @venueSpaces.map((space) =>
          id: space.id
          data: space
          segment: space.segment
          type: space.type
        )

      spacesTableData: ->
        for space in (@spaces || [])
          continue if space.id in @venueSpaceIds
          id: space.id
          data: space
          segment: space.segment
          size: space.size
          type: space.type

      optionsForBindSelector: ->
        title: 'Assets'
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        addButtonText: 'Add New Asset'
        addExistingButtonText: 'Add Existing Assets'

    methods:
      hiVenueSpacesSelectionChange: (spaces) ->
        @selectedVenueSpaces = spaces
      hiVenueSpacesRowClick: (row) ->
        @$refs.venueSpacesTable.toggleRowSelection row
      hiUnbindVenueSpace: (space) ->
        @unbindSpacesFromVenueTrigger [space]
      hiUnbindSelectedVenueSpaces: ->
        @unbindSpacesFromVenueTrigger @selectedVenueSpaces

      hiSpacesSelectionChange: (spaces) ->
        @selectedSpaces = spaces
      hiSpacesRowClick: (row) ->
        @$refs.spacesTable.toggleRowSelection row
      hiBindSpace: (space) ->
        @bindSpacesToVenueTrigger [space]
      hiBindSelectedSpaces: ->
        @$refs.bindSelector.close()
        @bindSpacesToVenueTrigger @selectedSpaces

      bindSpacesToVenueTrigger: (spaces) ->
        payload = { space_ids: spaces.map((s) => s.id) }
        @triggerResource 'venue_resource', 'bind_spaces', payload
      onVenueResourceBindSpaces: (_, item) ->
        @$emit 'change', item

      unbindSpacesFromVenueTrigger: (spaces) ->
        payload = { space_ids: spaces.map((s) => s.id) }
        @triggerResource 'venue_resource', 'unbind_spaces', payload
      onVenueResourceUnbindSpaces: (_, item) ->
        @$emit 'change', item
        @$refs.venueSpacesTable?.clearSelection()

export default VueOptions.vue settings
